import useEnv from "hooks/useEnv"
import useToast from "hooks/useToast"
import useUpload from "hooks/useUpload"
import { useState } from "react"
import { importOffersFile } from "services/offersApi"

interface ExportOffersReturn {
  loadingImport: boolean
  importOffers: () => void
  exportOffers: () => void
}

const useExportOffers = (): ExportOffersReturn => {
  const { apiUrl } = useEnv()
  const { toast } = useToast()
  const [loadingImport, setLoading] = useState<boolean>(false)

  const addPdfNode = async (file: File): Promise<void> => {
    const fd = new FormData()
    fd.append("file", file)

    try {
      setLoading(true)

      const jsonRes = await importOffersFile(file)

      toast("success", jsonRes.msg)
    } catch (err) {
      const error = err as Error
      toast("error", error.message)
    } finally {
      setLoading(false)
    }
  }

  const importOffers = useUpload(
    (files: File | FileList) => {
      if (files instanceof File) {
        addPdfNode(files)
      } else if (files.length > 0) {
        addPdfNode(files[0])
      }
    },
    {
      // accept: 'application/pdf',
      multiple: false,
    },
  )

  const exportOffers = (): void => {
    window.open(`${apiUrl}offers/export`)
  }

  return { loadingImport, importOffers, exportOffers }
}

export default useExportOffers
